module["exports"] = {
  "job": [
    "مشرف",
    "تنفيذي",
    "مدير",
    "مهندس",
    "متخصص",
    "رئيس مؤسسة",
    "منسق",
    "إداري",
    "مخطط",
    "محلل",
    "مصمم",
    "تقني",
    "مبرمج",
    "منتج",
    "مستشار",
    "مساعد",
    "وكيل",
    "متدرب"
  ]
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ar/name/title.js
// module id = 2386
// module chunks = 1610